export default __webpack_public_path__ + "i18n/translation-mr.66c8fc0b.json";